export const CAL_BOOKING_URL =
  'https://cal.com/mbhetech-solutions-rtnsl3/mbhetech-solutions-connect';
